/**
 * MetronomeIcon — a simple line-style metronome (matches the rest of the icon
 * set). With `animate`, the needle swings side to side (the `.metronome-needle`
 * keyframes live in App.css) — used by the "Calculating BPM…" popup.
 */

import React from 'react';

export default function MetronomeIcon({ size = 24, animate = false }: { size?: number; animate?: boolean }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* Body + base (static). */}
      <path d="M9 3.2h6l3.2 17.3H5.8L9 3.2z" />
      <line x1="5.8" y1="20.5" x2="18.2" y2="20.5" />
      {/* Swinging needle + weight, pivoting at its base. */}
      <g className={animate ? 'metronome-needle' : undefined}>
        <line x1="12" y1="20" x2="12" y2="6.5" />
        <circle cx="12" cy="10.5" r="1.2" fill="currentColor" stroke="none" />
      </g>
    </svg>
  );
}
